import { Chess } from 'chess.js';

// These are legal moves for the side to move, not an attack map. In particular,
// pinned pieces cannot expose their king, and pawns cannot move diagonally empty.
export function legalBoardHints(fen) {
  try {
    const chess = new Chess(fen);
    const turn = chess.turn();
    return {
      turn,
      checkedKing: chess.isCheck() ? chess.findPiece({ type: 'k', color: turn })[0] || null : null,
      moves: chess.moves({ verbose: true }).map(move => ({
        from: move.from,
        to: move.to,
        capture: !!move.captured,
        promotion: move.promotion || null,
        after: move.after,
      })),
    };
  } catch (error) {
    // Never substitute starting-position hints for an invalid saved snapshot.
    return { turn: null, checkedKing: null, moves: [] };
  }
}

export function destinationsForPiece(hints, square) {
  return [...new Map(hints.moves.filter(move => move.from === square).map(move => [move.to, { square: move.to, capture: move.capture }])).values()];
}

export function automaticMovePreview(previous, next, transition) {
  if (!previous || !transition || transition.backwards) return null;
  const main = transition.motions.find(motion => motion.id === 'main');
  if (!main) return null;
  const hints = legalBoardHints(previous.fen);
  // Verify the entire resulting position, including castling rights and turn.
  // A UCI-shaped string alone is not evidence of a legal historical move.
  if (!hints.moves.some(move => move.from === main.from && move.to === main.to && move.after === next.fen)) return null;
  return { fen: previous.fen, square: main.from, destinations: destinationsForPiece(hints, main.from) };
}
